(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(['exports', '../fonts/fonts'], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require('../fonts/fonts'));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.fonts);
    global.getStyleFromProps = mod.exports;
  }
})(this, function (exports, _fonts) {
  'use strict';

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.default = getStyleFromProps;
  function getStyleFromProps(props) {
    if (props.display1) return {
      fontFamily: _fonts.ProximaNova,
      fontSize: '60px',
      fontWeight: 600,
      lineHeight: 1.3
    };
    if (props.display2) return {
      fontFamily: _fonts.ProximaNovaT,
      fontSize: '60px',
      fontWeight: 100,
      lineHeight: 1.3
    };
    if (props.display3) return {
      fontFamily: _fonts.ProximaNovaA,
      fontSize: '42px',
      lineHeight: 1.31
    };
    if (props.headline1) return {
      fontFamily: _fonts.ProximaNova,
      fontSize: '34px',
      lineHeight: 1.29,
      fontWeight: 600
    };
    if (props.headline2) return {
      fontFamily: _fonts.ProximaNova,
      fontSize: '25px',
      lineHeight: 1.32
    };
  }
});


//////////////////
// WEBPACK FOOTER
// ./node_modules/@peachjar/components/build/styles/typography/getStyleFromProps.js
// module id = 1144
// module chunks = 0